import { useFeatures } from '@atc/features';

export default function usePreQualEligibility(listing) {

    const {
        thirdparty: [enableThirdParty],
        thirdparty_prequal: [, {
            autofi: isAutoFiPreQualEnabled = false,
            ford_motor_credit: isFordMotorCreditPreQualEnabled = false,
            roadster: isRoadsterDREnabled = false,
            westlake: isWestLakePreQualEnabled = false,
            carnow: isCarNowDREnabled = false,
            prequal_minimum_breakpoint: prequalMinimumBreakpoint,
        }],
    } = useFeatures(['thirdparty', 'thirdparty_prequal']);

    const {
        autoFiDealerCode,
        isRoadsterDigitalRetailing = false,
        isWestlakePrequal = false,
        pricingDetail: { salePrice = '', msrp = '' } = {},
        owner: { privateSeller: isPrivateSeller } = {},
        make,
        externalOwnerId = '',
        isCarNowDigitalRetailing = false,
    } = listing;

    const hasPrice = !!(salePrice || msrp);
    const isRoadsterEnabled = isRoadsterDigitalRetailing && isRoadsterDREnabled;
    const isWestlakeEnabled = isWestLakePreQualEnabled && isWestlakePrequal;
    const isFordMotorCreditEnabled = isFordMotorCreditPreQualEnabled && make?.code === 'FORD' && !!externalOwnerId;
    const isAutoFiEnabled = isAutoFiPreQualEnabled && autoFiDealerCode && !isRoadsterEnabled;
    const isAutoFiCTAEnabled = !!(isAutoFiPreQualEnabled && autoFiDealerCode);
    const isCarNowEnabled = isCarNowDREnabled && isCarNowDigitalRetailing;
    return {
        isWestlakeEnabled,
        isFordMotorCreditEnabled,
        isAutoFiEnabled,
        isAutoFiCTAEnabled,
        isPreQualEligible:
                enableThirdParty && hasPrice && !isPrivateSeller
                && (isWestlakeEnabled || isFordMotorCreditEnabled || isAutoFiEnabled),
        isRoadsterEnabled,
        isCarNowEnabled,
        prequalMinimumBreakpoint,
        enableThirdParty,
    };
}
